import { LazyLoadEarlyConstructorRequestCSR } from '@lentau/constructor/application/lazy-load-early-request.csr';
import { LazyLoadEarlyConstructorRequestSSR } from '@lentau/constructor/application/lazy-load-early-request.ssr';
import { ConstructorPageType } from '@lentau/constructor/shared/constants';
import { UrlsEnum } from '@lentau/ui-kit/core/enums/route.enum';
import { ActionCheck } from './interfaces';
import { LazyLoadEarlyCatalogItemsRequest } from '@lentau/catalog-redesign/listing/application/early-load/lazy-load-catalog-reqeust';

export const eagerEarlyActionLntCSR: ActionCheck[] = [
  {
    checkCondition: new RegExp(`^${UrlsEnum.Base}$`),
    action: () => LazyLoadEarlyConstructorRequestCSR(ConstructorPageType.mainPage),
  },
  {
    checkCondition: new RegExp(`^${UrlsEnum.MyAccount}`),
    action: () => LazyLoadEarlyConstructorRequestCSR(ConstructorPageType.profile),
  },
  {
    checkCondition: new RegExp(`^${UrlsEnum.Catalog}`),
    action: (url: string) => LazyLoadEarlyCatalogItemsRequest(url),
  },
];

export const eagerEarlyActionLntSSR: ActionCheck[] = [
  {
    checkCondition: new RegExp(`^${UrlsEnum.Base}$`),
    action: () => LazyLoadEarlyConstructorRequestSSR(ConstructorPageType.mainPage),
  },
  {
    checkCondition: new RegExp(`^${UrlsEnum.Catalog}`),
    action: (url: string) => LazyLoadEarlyCatalogItemsRequest(url),
  },
];

export const eagerEarlyActionUtkCSR: ActionCheck[] = [
  {
    checkCondition: new RegExp(`^${UrlsEnum.Base}$`),
    action: () => LazyLoadEarlyConstructorRequestCSR(ConstructorPageType.mainPage),
  },
];

export const eagerEarlyActionUtkSSR: ActionCheck[] = [
  {
    checkCondition: new RegExp(`^${UrlsEnum.Base}$`),
    action: () => LazyLoadEarlyConstructorRequestSSR(ConstructorPageType.mainPage),
  },
];

export const HYBRIS_UTM: string = 'utm_';
